import { myBTDataTracker } from "@features/mybt/utlis/helpers";
import { FeedTag } from "@routes/Keyword/utils/types";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface MyBtStore {
  tags: FeedTag[];
  setTags: (tags: FeedTag[]) => void;
  followTag: (tag: FeedTag) => void;
  unfollowTag: (tag: FeedTag) => void;
  isLimitModalShown: boolean;
  setIsLimitModalShown: (isLimitModalShown: boolean) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  myBtMessage: string;
  setMyBtMessage: (myBtMessage: string) => void;
  isMyBtBannerShown: boolean;
  setIsMyBtBannerShown: (isMyBtBannerShown: boolean) => void;
}

const useMyBtStore = create(
  persist<MyBtStore>(
    (set) => ({
      tags: [],
      setTags: (tags: FeedTag[]) => {
        set({ tags });
        myBTDataTracker(tags);
      },
      followTag: (tag: FeedTag) => {
        set((store) => {
          const updatedTags = [tag, ...store.tags];
          localStorage.setItem(
            "mybt-keywords",
            JSON.stringify({ tags: updatedTags })
          );
          myBTDataTracker(updatedTags); // Track data after updating the tags

          return { tags: updatedTags };
        });
      },
      unfollowTag: (tag: FeedTag) => {
        set((store) => {
          const updatedTags = store.tags.filter(
            (_tag) => _tag.name.toLowerCase() !== tag.name.toLowerCase()
          );
          localStorage.setItem(
            "mybt-keywords",
            JSON.stringify({ tags: updatedTags })
          );
          myBTDataTracker(updatedTags); // Track data after updating the tags

          return { tags: updatedTags };
        });
      },
      isLimitModalShown: false,
      setIsLimitModalShown: (isLimitModalShown: boolean) => {
        set({ isLimitModalShown });
      },
      isLoading: false,
      setIsLoading: (isLoading: boolean) => {
        set({ isLoading });
      },
      myBtMessage: "",
      setMyBtMessage: (myBtMessage: string) => {
        set({ myBtMessage });
      },
      isMyBtBannerShown: false,
      setIsMyBtBannerShown: (isMyBtBannerShown: boolean) => {
        set({ isMyBtBannerShown });
      },
    }),
    {
      name: "mybt-keywords", // unique name
      storage: createJSONStorage(() => localStorage), // Specify localStorage as the storage option
    }
  )
);

export default useMyBtStore;
